import React, { useEffect, useReducer, useContext, useRef } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import ActionsButtons from './ActionsButtons';
import SearchBox from './SearchBox';
import { store, reducer, initialState, actions } from './reducer';
import { store as mainStore } from '../../../../../store';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Lists from './Lists';
import Progress from '@material-ui/core/LinearProgress';
import Form from './Form';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Cities = () => {
  useTitle('مدیریت شهر ها')
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    page,
    inProgress,
    search: { title, state: stateTitle },
  } = state;
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const { Provider } = store;
  const firstTime = useRef(true);
  const timeout = useRef();

  const fetchingCities = async (page, itemsCountPerPage, title, state) => {
    const cities = await actions.fetchingCities(
      page,
      itemsCountPerPage,
      title,
      state
    );
    dispatch({ type: 'CITIES', payload: cities });
  };

  const refresh = ()=>{
    dispatch({ type: 'IN_PROGRESS', payload: true });
    fetchingCities(page, itemsCountPerPage, title, stateTitle);
  }

  useEffect(() => {
    if (firstTime.current) {
      dispatch({ type: 'IN_PROGRESS', payload: true });
      fetchingCities(page, itemsCountPerPage, title, stateTitle);
      firstTime.current = false;
    } else {
      dispatch({ type: 'IN_PROGRESS', payload: true });
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        fetchingCities(page, itemsCountPerPage, title, stateTitle);
      }, 1000);
    }
  }, [title, stateTitle, itemsCountPerPage, page]);

  return (
    <Provider value={{ state, dispatch, refresh }}>
      <FullCard title="مدیریت شهرها" actions={<ActionsButtons />}>
        <div className={classes.root}>
          <SearchBox />
          <Divider />
          {inProgress && <Progress />}
          <Lists />
        </div>
        <Form />
      </FullCard>
    </Provider>
  );
};

export default React.memo(Cities);
